import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import "firebase/performance";
import "firebase/firestore";


// Initialize Firebase
var config = {
  apiKey: "AIzaSyCTCZ23abjN4uPNIgt0Ygar92-TrYPZcU0",
  authDomain: "aramcco-crm.firebaseapp.com",
  databaseURL: "https://aramcco-crm-default-rtdb.firebaseio.com",
  projectId: "aramcco-crm",
  storageBucket: "aramcco-crm.appspot.com",
  messagingSenderId: "123195959624",
  appId: "1:123195959624:web:a3b205944b14642ad4ab7d",
  measurementId: "G-CVPLYVXCJK"
};
firebase.initializeApp(config);

const db = firebase.database();
const store = firebase.firestore();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();

export {
  firebase,
  db,
  auth,
  store,
  perf,
  storageRef
};
